// extracted by mini-css-extract-plugin
export default {"nothing":"LinkedUsers_nothing__Vj4uy","content":"LinkedUsers_content__vatio","placeHolderShimmer":"LinkedUsers_placeHolderShimmer__C1JqO"};